// extracted by extract-css-chunks-webpack-plugin
module.exports = {"cashpassCard":"b0Ypw"};